import track from './track.js'

/**
 * 注册 v-track 指令
 * 用法：v-track="{ code: 'search', name: '查询', type: 'search' }"
 *      v-track="{ code: 'export', name: '导出' }"
 *
 * 注意：binding 值挂在 el 上，并在 update 时刷新。
 * 避免同类型 a-button 被 Vue 复用时，闭包仍持有旧的 code/name。
 */
export function registerTrackDirective(Vue) {
  Vue.directive('track', {
    bind(el, binding) {
      el.__trackBinding = binding.value
      el.__trackHandler = function () {
        const v = el.__trackBinding || {}
        if (v.type === 'search') {
          track.search(v)
        } else {
          track.click(v)
        }
      }
      el.addEventListener('click', el.__trackHandler, true)
    },
    update(el, binding) {
      el.__trackBinding = binding.value
    },
    unbind(el) {
      if (el.__trackHandler) {
        el.removeEventListener('click', el.__trackHandler, true)
        delete el.__trackHandler
      }
      delete el.__trackBinding
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/track/directive.js